export default {
  bind(el, binding, vnode) {
    const dropdown = el.querySelector('.multiselect__content-wrapper');
    if (!dropdown) return;
    dropdown.style.transition = 'visibility 0.2s, opacity 0.2s';

    el.updateDropdownPosition = () => {
      const above = el.classList.contains('multiselect--above');
      const rect = el.getBoundingClientRect();
      dropdown.style.position = 'absolute';
      dropdown.style.zIndex = 9999;
      dropdown.style.width = `${rect.width}px`;
      dropdown.style.left = `${rect.left + window.scrollX}px`;
      if(above){
        const dropdownHeight = dropdown.offsetHeight;
        dropdown.style.top = `${rect.top + window.scrollY - dropdownHeight}px`;
        dropdown.style.borderRadius = '5px 5px 0 0';
      } else {
        dropdown.style.top = `${rect.bottom + window.scrollY}px`;
        dropdown.style.borderRadius = '0 0 5px 5px';
      }
    };

    document.body.appendChild(dropdown);
    
    vnode.componentInstance.$on('open', () => {
      el.updateDropdownPosition();
      window.addEventListener('scroll', el.updateDropdownPosition, true);
      window.addEventListener('resize', el.updateDropdownPosition);
    });
    vnode.componentInstance.$on('close', () => {
      window.removeEventListener('scroll', el.updateDropdownPosition, true);
      window.removeEventListener('resize', el.updateDropdownPosition);
    });
  },
  unbind(el) {
    if (el.__observer) {
      el.__observer.disconnect();
    }
    window.removeEventListener('scroll', el.updateDropdownPosition, true);
    window.removeEventListener('resize', el.updateDropdownPosition);
  },
};
